"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var ExtendableError = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(ExtendableError, _super);
    function ExtendableError(message) {
        var _this = _super.call(this, message) || this;
        Object.defineProperty(_this, 'message', {
            enumerable: false,
            value: message,
        });
        Object.defineProperty(_this, 'name', {
            enumerable: false,
            value: _this.constructor.name,
        });
        Error.captureStackTrace(_this, _this.constructor);
        return _this;
    }
    return ExtendableError;
}(Error));
exports.default = ExtendableError;
//# sourceMappingURL=ExtendableError.js.map